import React from 'react';
import { DSPlusIcon } from '@ds-icons';
import { NodeViewProps } from '@tiptap/core';

const AddHandle = ({ editor, getPos }: NodeViewProps) => {
  const handleAdd = (e: React.MouseEvent) => {
    e.stopPropagation();
    const pos = getPos();
    editor
      .chain()
      .focus()
      .insertContentAt(pos + editor.state.doc.nodeAt(pos)!.nodeSize, {
        type: 'blockItem',
        content: [{ type: 'paragraph' }]
      })
      .run();
  };

  return (
    <span
      className="add-handle"
      contentEditable={false}
      tabIndex={-1}
      onClick={handleAdd}
      aria-label="Add block below"
    >
      <DSPlusIcon />
      <span className="block-item-tooltip">
        <strong className="block-item-tooltip-action">Click</strong>
        <span className="block-item-tooltip-desc"> to add below</span>
      </span>
    </span>
  );
};

export default AddHandle;
